<template>
  <div class="wrapper" style="background:#57CB4A;">
      <router-link :to="{ path: '/timeline' }" replace>
        <img src="./../../assets/back2.png" class="pos_abs" style="width:28vw;left:36vw;bottom:5vw;position:fixed;">
      </router-link>
    <img src="./../../assets/rankTitle.png" width="100%" alt="" style="margin-top:5vw;">
    <div class="rankList auto">
      <ul class="auto">
        <li v-for="(item,index) in rankArr" :key="index">
          <div>{{item.index}}</div>
          <div>{{item.name==null?'川观用户':item.name}}</div>
          <div>{{item.score}}</div>
        </li>
      </ul>
    </div>
    <div style="text-align:center;text-decoration:underline; color:rgb(57 136 47);font-size:12px;width:89vw;border-top:5vw solid rgb(255 194 77);margin-left:4.7vw;padding:5vw 0;margin-bottom:15vw;">说明：分数相同则排名一致</div>
  </div>
</template>
  <script>
import { rank } from "@/apis/olympic";
export default {
  data() {
    return {
      rankArr: [],
    };
  },
  created() {
    let reg =
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    rank().then((resp) => {
      var _this = this;
      var getData = resp.data;
      getData.map(function (item, index) {
        console.log(index);
        if (reg.test(Number(item.name))) {
          item.name =
            item.name.substring(0, 3) + "****" + item.name.substring(7, 11);
        }
        _this.rankArr.push(item);
      });
    });
  },
  methods: {},
};
</script>
  <style lang="scss" scoped>
@import "./../common.scss";

.rankTop {
  width: 100vw;
  height: 14.93vw;
  background: url(./../../assets/rankTop.jpg) no-repeat center top;
  background-size: 100% 100%;
  padding-top: 1px;
  line-height: 14vw;
  text-align: center;
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
}
.rankList {
  background: url(./../../assets/rankRepeat.jpg) repeat-y center top;
  background-size: 100% auto;
  min-height: 150vw;
  padding-bottom: 1px;
  ul {
    width: 82.13vw;
    li {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 3vw;
      div {
        text-align: center;
        &:nth-child(1) {
          width: 17%;
        }
        &:nth-child(2) {
          width: 45%;
          text-align: left;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
        &:nth-child(3) {
          width: 22%;
          text-align: left;
        }
      }
    }
  }
}
</style>